import React, {useState} from "react";
import {FieldFeedbackLabel} from "./FieldFeedbackLabel";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {VisibilityOff} from "@material-ui/icons";

const getFieldCSSClasses = (touched, errors) => {
    const classes = ["form-control"];
    // if (touched && errors) {
    //     classes.push("is-invalid");
    // }
    //
    // if (touched && !errors) {
    //     classes.push("is-valid");
    // }

    return classes.join(" ");
};

export function Input({
                          field, // { name, value, onChange, onBlur }
                          form: {touched, errors}, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          label,
                          withFeedbackLabel = true,
                          withCustomError = false,
                          errorLabel,
                          customFeedbackLabel,
                          type = "text",
                          ...props
                      }) {
    return (
        <>
            {label && <label>Enter {label}</label>}
            <input
                type={type}
                className={getFieldCSSClasses(touched[field.name], errors[field.name])}
                {...field}
                {...props}
            />
            {
                withCustomError &&
                <span>
                    <label style={{
                        "margin-top": "8px",
                        "color": "red"
                    }}>{errorLabel}</label>
                </span>
            }

            {withFeedbackLabel && (
                <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                />
            )}
        </>
    );
}

export function InputPassword({
                                  field, // { name, value, onChange, onBlur }
                                  form: {touched, errors}, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                  label,
                                  withFeedbackLabel = true,
                                  withCustomError = false,
                                  errorLabel,
                                  customFeedbackLabel,
                                  type = "text",
                                  ...props
                              }) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            {label && <label>Enter {label}</label>}
            <div className="fv-row" data-kt-password-meter="true">
                <div className="mb-1">
                    <div className="position-relative mb-3">
                        <input
                            className={getFieldCSSClasses(touched[field.name], errors[field.name])}
                            {...field}
                            {...props}
                            type={showPassword ? "text" : "password"} placeholder="" name="new_password"
                            autoComplete="off"
                            style={{
                                "padding-right": "40px"
                            }}
                        />
                        <span
                            className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                            data-kt-password-meter-control="visibility" style={{
                            "top": "3px",
                            "right": "5px",
                            "visibility": props.value !== '' && props.value !== undefined && props.value !== null ? "visible" : "hidden"
                        }}>
                            <IconButton onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <VisibilityIcon/> : <VisibilityOff/>}
                            </IconButton>
                        </span>
                    </div>
                </div>
            </div>
            {
                withCustomError &&
                <span>
                        <label style={{
                            "margin-top": "8px",
                            "color": "red"
                        }}>
                            {errorLabel}
                        </label>
                    </span>
            }
        </>
    );
}
